<script lang="ts">
  import * as icons from "../Icons/strings"

  export let features: any
  export let downloads = 0
  export let expand = false
  $: fieldCount = features?.fields?.length - 1 ?? 0
  $: usesLogic = features?.logic > 0 ?? false
  $: multiStep = features?.pages > 1 ?? false
  function format(value: number | string) {
    const valueNumeric = Number(value)
    return new Intl.NumberFormat().format(valueNumeric)
  }
  let crumbs: {
    text: string
    icon: string
    suffix: string
  }[] = []
  $: buildCrumbs(features, downloads)

  function buildCrumbs(features: any, downloads: number) {
    crumbs = []
    if (downloads && downloads !== 0) {
      crumbs.push({
        text: format(downloads),
        icon: icons.Download,
        suffix: "downloads",
      })
    }
    crumbs.push({
      text: fieldCount.toString(),
      icon: icons.InputField,
      suffix: "fields",
    })
    if (multiStep) {
      crumbs.push({
        text: features.pages.toString(),
        icon: icons.Pages,
        suffix: "steps",
      })
    }
  }
</script>

<div class="text-gray-500 flex flex-row items-center {$$props.class || ''}">
  {#each crumbs as crumb, i}
    <div class="flex flex-row items-center">
      <div class="feature-item">
        {#if expand === false}
          {crumb.text}
          <span class="feature-icon">{@html crumb.icon}</span>
        {:else}
          <span class="feature-icon">{@html crumb.icon}</span>
          {crumb.text}
          {crumb.suffix}
        {/if}
      </div>
      {#if i < crumbs.length - 1}
        <svg
          class="flex items-center justify-center w-4"
          width="2.5"
          height="2.5"
          viewBox="0 0 100 100"
          fill="currentColor"
        >
          <circle cx="50%" cy="50%" r="50%" fill="currentColor"></circle>
        </svg>
      {/if}
    </div>
  {/each}
</div>

<style lang="postcss">
  .feature-item {
    display: flex;
    flex-flow: row;
    align-items: center;
    gap: 0.25rem;
    font-size: 12px;
  }
  .feature-item .feature-icon {
    display: inline-block;
    width: 1rem;
    height: 1rem;
  }
</style>
